"use client";

import { routes } from "@/data/routes";
import { useScrollDistance } from "@/hooks/useScrollDistance";
import { cn } from "@/lib/components";
import Logo from "@/svg/logo.svg";
import { ReactNode } from "react";
import { default as data, default as headerData } from "./Header.data";
import { HeaderSidebar } from "./HeaderSidebar";
import { Nav } from "./Nav";

export function Header({
  isHomePage,
  iconLinks,
}: {
  isHomePage: boolean;
  iconLinks: {
    icon: ReactNode;
    href?: string;
  }[];
}) {
  const scrollDistance = useScrollDistance();
  const headerColors =
    isHomePage && scrollDistance < headerData.scrollThreshold
      ? headerData.colors.transparent
      : headerData.colors.default;

  return (
    <header
      className={cn(
        "flex items-center justify-between",
        "z-20 h-16 w-full px-4 md:px-16 xl:px-32",
        "transition-all duration-300",
        isHomePage && "fixed top-0 left-0",
        headerColors.header,
        headerColors.text,
      )}
    >
      <Nav className="flex items-center gap-6">
        <li className="flex">
          <HeaderSidebar triggerClassName={cn(headerColors.text, "hover:opacity-70")} />
        </li>
        <Nav.Link href={routes.home.path}>
          <Logo className="h-8" />
        </Nav.Link>
      </Nav>
      <div className="flex gap-14">
        <Nav className="hidden gap-5 md:flex">
          {data.links.map((route) => (
            <Nav.Link key={route.label} href={route.path}>
              {route.label}
            </Nav.Link>
          ))}
        </Nav>

        <Nav className="flex gap-5">
          {iconLinks.map((link, lidx) =>
            link.href ? (
              <Nav.Link key={link.href} href={link.href} className="relative">
                {link.icon}
              </Nav.Link>
            ) : (
              <Nav.Item key={"link_" + lidx} className="relative">
                {link.icon}
              </Nav.Item>
            ),
          )}
        </Nav>
      </div>
    </header>
  );
}
